<template>
  <input
    class="form-control input-sm"
    :id="id"
    autocomplete="off"
    v-model="seleted"
    type="text"
    data-provide="datepicker"
    data-date-language="th-th"
  />
</template>

<script>
import moment from 'moment'

import { DATE_FORMAT } from '@/lib/global'

export default {
  name: 'DatePickerTH',
  props: ['type', 'value'],
  data() {
    return {
      id: Math.random()
        .toString(36)
        .substring(7),
      seleted: '',
      date: {
        human: '',
        origin: '',
      },
    }
  },
  watch: {
    value(val) {
      this.setDate(val)
    },
  },
  mounted() {
    const datePickerSelector = $(`#${this.id}`)

    datePickerSelector.datepicker().on('changeDate', () => {
      this.date = {
        human: datePickerSelector.val(),
        origin: this.formatDate,
      }

      this.$emit('input', this.date)
    })

    this.init()
  },
  computed: {
    formatDate: function() {
      const datePickerSelector = $(`#${this.id}`)
      const d = datePickerSelector.val().split('/')

      return d[2] - 543 + '-' + d[1] + '-' + d[0]
    },
  },
  methods: {
    init() {
      const today = moment().format(DATE_FORMAT)
      const oneMonthBehind = moment()
        .subtract(1, 'months')
        .format(DATE_FORMAT)
      const oneMonthAhead = moment()
        .add(1, 'months')
        .format(DATE_FORMAT)

      const datePickerSelector = $(`#${this.id}`)

      if (this.type == 'birthday') {
        datePickerSelector.datepicker('setEndDate', oneMonthBehind)
      } else if (this.type == 'effective_date') {
        datePickerSelector.datepicker('setStartDate', today)
        datePickerSelector.datepicker('setEndDate', oneMonthAhead)
      } else if (this.type == 'past') {
        datePickerSelector.datepicker('setEndDate', today)
      }
    },
    setDate(dateSelect) {
      const datePickerSelector = $(`#${this.id}`)
      const date_select =
        dateSelect.substr(0, 2) + '/' + dateSelect.substr(2, 2) + '/' + dateSelect.substr(4, 4)
      datePickerSelector.val(date_select)
      this.date = {
        human: datePickerSelector.val(),
        origin: this.formatDate,
      }

      this.$emit('input', this.date)
    },
  },
}
</script>
